export default __webpack_public_path__ + "assets/images/6ff28e678771cc6dc7b6f6edf060fe17.svg";